import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface RawResult {
  updateTelephoneKey: boolean;
}

export type Args = {
  id: string;
  room_id: string;
};

export const updateTelephoneKey = async <V>(
  apollo: DollarApollo<V>,
  args: Args
): Promise<FetchResult<RawResult>> => {
  const { id, room_id } = args;
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: {
      id,
      room_id
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
